<app-sub-menu [subMenus]="subMenus"></app-sub-menu>
<div class="container-fluid bg-box container-custom">
  <div class="row mb-3">
    <div class="col">
      <h3>{{ title }}</h3>
    </div>
    <div class="col text-right">
      <button
        class="btn btn-primary primary"
        data-bs-toggle="modal"
        data-bs-target="#modalAltaRevision"
        [disabled]="disableBtnNewRevision"
      >
        Nueva Revisión
      </button>
    </div>
  </div>
  <hr />
  <div class="row">
    <div class="col-12">
      <div
        class="table-responsive"
      >
        <table
          #tableContainer
          id="tblRevision"
          class="table table-bordered table-hover"
          [class.table-striped]="collectionRevisiones"
        >
          <thead>
            <tr>
              <th scope="col">Estatus</th>
              <th scope="col">Folio</th>
              <th scope="col">Objetivo</th>
              <th scope="col">Alcance</th>
              <th scope="col">Nombre</th>
              <th scope="col">Tipo</th>
              <th scope="col">Región</th>
              <th scope="col">Estación</th>
              <th scope="col">Fecha inicio plan</th>
              <th scope="col">Fecha fin plan</th>
              <th scope="col">Editar</th>
              <th scope="col">Eliminar</th>
            </tr>
          </thead>
          <tbody *ngIf="collectionRevisiones; else loading">
            <tr *ngFor="let revision of collectionRevisiones">
              <td>
                <div class="badges">
                  <span
                    [ngStyle]="{ 'background-color': revision.Etapa?.Color }"
                    class="badges--publicado"
                  >
                    {{ revision.Etapa?.Descripcion }}
                  </span>
                </div>
              </td>
              <td>{{ revision.IdRevision }}</td>
              <td><a>{{ revision.objetivo }}</a></td>
              <td><a>{{ revision.alcance }}</a></td>
              <td>{{ revision.Descripcion }}</td>
              <td>{{ revision.TipoRevision?.Descripcion }}</td>
              <td>{{ revision.Region?.Nombre }}</td>
              <td>{{ revision.Estacion?.Nombre }}</td>
              <td>{{ datetimeToDateFormat(revision.FechaInicioPlan) }}</td>
              <td>{{ datetimeToDateFormat(revision.FechaFinPlan) }}</td>
              <td class="text-center" title="Editar objetivo y alcance">
                <button
                  type="button"
                  class="btn btn-primary btn-sm rounded-circle"
                  (click)="
                    editObjetivoClick(
                      revision.IdRevision,
                      revision.objetivo,
                      revision.alcance
                    )
                  "
                >
                  <i class="fa fa-eye"></i>
                </button>
              </td>
              <td class="text-center">
                <button
                  [disabled]="revision.IdEtapa != 1"
                  type="button"
                  class="btn btn-danger btn-sm rounded-circle"
                  (click)="eliminarRevision(revision.IdRevision)"
                >
                  <i class="fa fa-minus"></i>
                </button>
              </td>
            </tr>
            <tr *ngIf="!loadRows">
              <td colspan="12" class="text-center">
                <button
                  class="btn btn-lg btn-outline-dark text-uppercase w-100"
                  (click)="loadRevisiones()"
                >
                  Cargar mas Revisiones
                </button>
              </td>
            </tr>
            <tr *ngIf="loadRows">
              <td colspan="12" class="text-center">
                <p>CARGANDO...</p>
              </td>
            </tr>
          </tbody>
          <ng-template #loading>
            <tbody>
              <tr *ngFor="let item of [].constructor(7)">
                <td colspan="4">
                  <div
                    class="w-100 p-3 rounded border border-white skeleton"
                  ></div>
                </td>
                <td colspan="4">
                  <div
                    class="w-100 p-3 rounded border border-white skeleton"
                  ></div>
                </td>
                <td colspan="4">
                  <div
                    class="w-100 p-3 rounded border border-white skeleton"
                  ></div>
                </td>
              </tr>
            </tbody>
          </ng-template>
        </table>
      </div>
    </div>
  </div>
</div>

<!--Modal nueva revisión-->
<div
  class="modal fade bd-example-modal-lg"
  id="modalAltaRevision"
  tabindex="-1"
  role="dialog"
  aria-labelledby="modalAltaRevisionLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <app-form-new-revision
      [negocios]="negocios"
      [tipoRevisiones]="tipoRevisiones"
      (saveRevision)="saveRevisionChild($event)"
    />
  </div>
</div>

<div
  class="modal fade bd-example-modal-lg"
  id="modalEditObjetivo"
  tabindex="-1"
  role="dialog"
  aria-labelledby="modalEditObjetivoLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <app-form-edit-revision
      [idRevision]="revisionId"
      [alcance]="alcance"
      [objetivo]="objetivo"
      (revisionUpdate)="revisionUpdateChild($event)"
    />
  </div>
</div>
